/*
 * Model for the Add Representative view
*/

rs.module("framework/content/representatives/add",

    ["common/select-helper"],

    function (selectHelper) {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        var _codeValues;

        var _form;
        var _personNonPersonIndicators;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, codeValues, duplicatePersonLookup) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;
            _codeValues = codeValues;

            _form = $.js(_jsSelectors.form);
            _personNonPersonIndicators = _form.js(_jsSelectors.personNonPersonIndicators);

            // Register click event to person/non person indicators to toggle identification fields
            _personNonPersonIndicators.find("input").on("click", _togglePersonNonPerson);

            // Register click event for changing identity once an identity has previously been verified
            _form.js(_jsSelectors.changeIdentityLink).click(function () { _togglePageForIdentityVerified(false); });

            // Tell duplicate person lookup where to pull lookup parameters from
            duplicatePersonLookup.onGetLookupParameters(function () {

                // Validate form before performing duplicate lookup
                var validator = _form.validate();
                var isValid = validator.form();

                // only send lookup parameters if form is valid
                if (isValid) {

                    var isPerson = _personNonPersonIndicators.find("input:checked").val() == "";

                    return {
                        isPerson: isPerson,
                        nonPersonType: isPerson ? null : _personNonPersonIndicators.find("input:checked").val(),
                        tin: isPerson ? _form.js(_jsSelectors.ssn).val().replace(/-/g, "").replace(/ /g, "") : _form.js(_jsSelectors.tin).val().replace(/-/g, "").replace(/ /g, ""),
                        firstName: isPerson ? _form.js(_jsSelectors.firstName).val().trim() : null,
                        lastName: isPerson ? _form.js(_jsSelectors.lastName).val().trim() : null,
                        nonPersonName: isPerson ? null : _form.js(_jsSelectors.nonPersonName).val().trim()
                    }
                }

                return null;
            });

            // Hookup callback function to be executed when duplicate selection is complete
            duplicatePersonLookup.onDuplicateSelectionComplete(_duplicateSelectionComplete);
        }

        //
        // Click event for person/nonperson indicators
        //
        function _togglePersonNonPerson() {
            var isPerson = this.value == 0;

            _form.js(_jsSelectors.personDemographics).toggleClass(_cssClasses.hidden, !isPerson);
            _form.js(_jsSelectors.nonPersonDemographics).toggleClass(_cssClasses.hidden, isPerson);
        }

        //
        // Callback to execute when duplicate selection is complete
        //
        function _duplicateSelectionComplete(participantKey) {

            // set hidden fields to be able to post values back on save since we will be disabling the identity fields
            _form.js(_jsSelectors.nonPersonTypeHidden).val(_personNonPersonIndicators.find("input:checked").val());
            _form.js(_jsSelectors.prefixHidden).val(_form.js(_jsSelectors.prefix).val().trim());
            _form.js(_jsSelectors.firstNameHidden).val(_form.js(_jsSelectors.firstName).val().trim());
            _form.js(_jsSelectors.middleNameHidden).val(_form.js(_jsSelectors.middleName).val().trim());
            _form.js(_jsSelectors.lastNameHidden).val(_form.js(_jsSelectors.lastName).val().trim());
            _form.js(_jsSelectors.suffixHidden).val(_form.js(_jsSelectors.suffix).val().trim());
            _form.js(_jsSelectors.ssnHidden).val(_form.js(_jsSelectors.ssn).val().trim());
            _form.js(_jsSelectors.nonPersonNameHidden).val(_form.js(_jsSelectors.nonPersonName).val().trim());
            _form.js(_jsSelectors.tinHidden).val(_form.js(_jsSelectors.tin).val().trim());

            if (participantKey == -1) {

                // Since this is a new person we know there is no Main contact info on file
                _form.js(_jsSelectors.mainContactInfoOnFileHidden).val(false);
                _form.js(_jsSelectors.contactInfo).toggleClass(_cssClasses.hidden, false);
                _form.js(_jsSelectors.mainContactInfoMessage).toggleClass(_cssClasses.hidden, true);

                _togglePageForIdentityVerified(true);

                // move focus to next enabled input
                _form.find(`[data-js~=${_jsSelectors.detail}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.contactInfo}] :tabbable:not(:disabled)`).first().focus();
            }
            else {

                // Is the duplicate a person
                var isPerson = _form.js(_jsSelectors.personNonPersonIndicators).find("input:checked").val() == "";

                // Retrieve existing person/nonperson info
                $.post(_backendUrls.loadExistingParticipantInfo,
                    {
                        participantKey: participantKey,
                        isPerson: isPerson

                    }).done(function (result) {

                        if (isPerson) {

                            _form.js(_jsSelectors.existingParticipantKey).val(result.person.personKey);

                            // populate identity inputs with the retrieved info for the duplicate person
                            _form.js(_jsSelectors.ssn).val(result.person.ssn);
                            _form.js(_jsSelectors.prefix).val(result.person.namePrefix);
                            _form.js(_jsSelectors.firstName).val(result.person.firstName);
                            _form.js(_jsSelectors.middleName).val(result.person.middleName);
                            _form.js(_jsSelectors.lastName).val(result.person.lastName);
                            _form.js(_jsSelectors.suffix).val(result.person.nameSuffix);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.ssnHidden).val(result.person.ssn);
                            _form.js(_jsSelectors.prefixHidden).val(result.person.namePrefix);
                            _form.js(_jsSelectors.firstNameHidden).val(result.person.firstName);
                            _form.js(_jsSelectors.middleNameHidden).val(result.person.middleName);
                            _form.js(_jsSelectors.lastNameHidden).val(result.person.lastName);
                            _form.js(_jsSelectors.suffixHidden).val(result.person.nameSuffix);
                        }
                        else {

                            _form.js(_jsSelectors.existingParticipantKey).val(result.nonPerson.nonPersonKey);

                            // populate identity inputs with the retrieved info for the duplicate nonperson
                            _form.js(_jsSelectors.nonPersonName).val(result.nonPerson.name);
                            _form.js(_jsSelectors.tin).val(result.nonPerson.tin);

                            // copy values into hidden fields to be able to post values back on save since the identity fields are disabled
                            _form.js(_jsSelectors.nonPersonNameHidden).val(result.nonPerson.name);
                            _form.js(_jsSelectors.tinHidden).val(result.nonPerson.tin);
                        }

                        _form.js(_jsSelectors.mainContactInfoOnFileHidden).val(result.mainContactInfoOnFile);

                        _form.js(_jsSelectors.contactInfo).toggleClass(_cssClasses.hidden, result.mainContactInfoOnFile);
                        _form.js(_jsSelectors.mainContactInfoMessage).toggleClass(_cssClasses.hidden, !result.mainContactInfoOnFile);

                        // Once all inputs are populated toggle sections/fields for identity verified
                        _togglePageForIdentityVerified(true);

                        // move focus to next enabled input
                        _form.find(`[data-js~=${_jsSelectors.detail}] :tabbable:not(:disabled), [data-js~=${_jsSelectors.contactInfo}] :tabbable:not(:disabled)`).first().focus();
                    });
            }
        }

        //
        // Enable/disable sections based on whether identity has been verified
        //
        function _togglePageForIdentityVerified(identityVerified) {

            _form.js(_jsSelectors.identityVerified).val(identityVerified);
            _form.js(_jsSelectors.saveButton).setDisabled(!identityVerified);

            _toggleIdentitySection(!identityVerified);
            _toggleDetailSection(identityVerified);
            _toggleContactInfoSection(identityVerified);

            _resetValidations();
        }

        //
        // Enable/disable the identity section
        //
        function _toggleIdentitySection(enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(_jsSelectors.identity).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable);

            // Have to use select helper to enable/disable any selects
            _form.js(_jsSelectors.identity).find("select").each(function () {
                $(this).attr("data-val", enable);
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });

            _form.js(_jsSelectors.duplicatePersonLookup).toggle(enable);
            _form.js(_jsSelectors.changeIdentityLink).toggleClass(_cssClasses.hidden, enable);
        }

        //
        // Enable/disable the detail section
        //
        function _toggleDetailSection(enable) {

            // enable/disable all non-hidden inputs in the section
            _form.js(_jsSelectors.detail).find("input").not("[type=hidden]").prop("disabled", !enable).attr("data-val", enable).clearErrors();

            // Have to use select helper to enable/disable any selects
            _form.js(_jsSelectors.detail).find("select").each(function () {
                $(this).attr("data-val", enable).clearErrors();
                selectHelper.getHelper($(this)).setDisabled(!enable);
            });
        }

        //
        // Enable/disable the contact info section
        //
        function _toggleContactInfoSection(enable) {

            // Have to use select helper to disable/clear any selects
            _form.js(_jsSelectors.contactInfo).find("select").each(function () {

                var helper = selectHelper.getHelper($(this).clearErrors()).setDisabled(!enable);

                if (!enable) {
                    helper.setValue(null);
                }
            });

            // enable/disable all inputs
            var inputs = _form.js(_jsSelectors.contactInfo).find("input").prop("disabled", !enable).clearErrors();

            if (!enable) {
                inputs.val(null);

                // default country and country code to USA for convenience
                selectHelper.getHelper(_form.js(_jsSelectors.countrySelect)).setValue(_codeValues.usa);
                _form.js(_jsSelectors.countryCodeInput).val("1");
            }

            //reset form validations
            _resetValidations();

        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {
            $.validator.resetValidation(_form);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);